import type { ExpectedProgressStatus } from '@bigint-project/core';

/**
 * 預期進度狀態的共用顯示語彙。
 *
 * 看板、工時網格、任務進度對話框與任務表格都要顯示同一個 `status`，
 * 各自寫一份對照表的結果是同一個狀態在四個畫面叫四個名字、配四種顏色。
 */
export const PROGRESS_STATUS_LABEL: Record<ExpectedProgressStatus, string> = {
  notStarted: '未開始',
  behind: '落後',
  onTrack: '如期',
  ahead: '超前',
  complete: '已完成',
};

/** 徽章樣式（有底色）：落後醒目、超前與完成正向、其餘不搶眼。 */
export function progressStatusBadgeClass(status: ExpectedProgressStatus): string {
  if (status === 'behind') return 'bg-danger-soft text-danger';
  if (status === 'ahead' || status === 'complete') return 'bg-ok-soft text-ok';
  return 'bg-raised text-fg-muted';
}

/** 純文字樣式（表格儲存格用，不加底色）；顏色語意與徽章一致。 */
export function progressStatusTextClass(status: ExpectedProgressStatus): string {
  if (status === 'behind') return 'text-danger';
  if (status === 'ahead' || status === 'complete') return 'text-ok';
  return 'text-fg-muted';
}
